import { createFileRoute } from "@tanstack/react-router";
import { ScaleIcon } from "lucide-react";
import { LawsTable } from "@/components/admin/laws/laws-table";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/laws")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "laws"),
  component: AdminLawsPage,
});

function AdminLawsPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <ScaleIcon className="size-3.5" />
          Governance
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading text-3xl font-semibold tracking-tight">Laws</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            A reference library of the laws and rules that apply to generated HR documents. Each
            entry pairs a rule heading with a country, and can be tagged with a document type — so,
            for example, an NDA generated for a given jurisdiction can surface the relevant statute.
          </p>
        </div>
      </header>

      <LawsTable />
    </div>
  );
}
